<template>
  <client-only>
    <div
      v-show="isPopoverVisible"
      class="new-navbar-user-menu z-30 overflow-hidden absolute shadow-lg bg-neutral-00"
    >
      <transition name="fade" appear>
        <div
          v-if="!isLoggedIn"
        >
          <div class="py-4 px-6 border-b border-neutral-200">
            <NewButton tag="nuxt-link" to="/signup" icon-right="new-chevron-right" class="w-full">
              {{ $t('HomePage.Signup') }}
            </NewButton>
          </div>
          <div class="py-4 px-6">
            <NewButton
              color="white"
              variant="outline"
              tag="nuxt-link"
              to="/login"
              icon-right="new-chevron-right"
              class="w-full"
            >
              {{ $t('LoginForm.Login') }}
            </NewButton>
          </div>
        </div>
        <div v-else>
          <div class="py-4 px-6 flex items-center border-b border-neutral-200">
            <OSvg svg="user" class="w-5 fill-neutral-800" />
            <div>
              <p class="ml-2 o-caption font-bold text-left" v-text="name" />
              <p class="ml-2 o-caption whitespace-no-wrap" v-text="email" />
            </div>
          </div>
          <button
            class="py-3 px-6 flex items-center w-full hover:bg-neutral-50 transition-all ease-in"
            @click="onAccountClick"
          >
            <OSvg svg="new-home-outline" class="w-5 fill-neutral-800" />
            <p class="ml-2 o-caption font-bold" v-text="$t('Navbar.UserMenu.Dashboard')" />
          </button>
          <button
            class="py-3 px-6 flex items-center w-full hover:bg-neutral-50 transition-all ease-in"
            @click="$emit('logout')"
          >
            <OSvg svg="new-log-out" class="w-5 fill-neutral-800" />
            <p class="ml-2 o-caption font-bold" v-text="$t('Navbar.UserMenu.LogOut')" />
          </button>
        </div>
      </transition>
    </div>
  </client-only>
</template>

<script>
import NewButton from '@/components/NewButton'
import OSvg from '@/components/OSvg'

export default {
  name: 'UserMenu',
  components: { NewButton, OSvg },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isPopoverVisible: false
    }
  },
  methods: {
    togglePopover (isVisible) {
      this.isPopoverVisible = isVisible
    },
    onClickOutside () {
      if (this.isPopoverVisible) {
        this.togglePopover(false)
      }
    },
    onAccountClick () {
      this.onClickOutside()

      this.$router.push(this.$i18n.localePath({ name: 'account' }))
    }
  }
}
</script>

<style scoped lang="postcss">
.new-navbar-user-menu {
  border-radius: 1.6rem;
  right: 3%;
  width: min-content;
  top: 6rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

a {
  white-space: nowrap;
}

@screen lg {
  .new-navbar-user-menu {
    top: 8rem;
  }
}
</style>
